import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Button, {
  ProfileOwnerWatchButton,
} from '@wix/da-shared-react/pkg/Button';
import WatchButtonConneсtContainer from '../WatchButton.container';
import Sticky from '@wix/da-shared-react/pkg/Sticky';
import SubNavBarMobileInner from './SubNavBarMobileInner';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import {
  withVerification,
  WithVerificationProps,
} from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';
import { SubNavBarProps } from '../SubNavBar';

import cssVars from '@wix/da-ds/src/styles/variables.scss';
import s from './SubNavBarMobile.scss';

const WatchButtonMobile = WatchButtonConneсtContainer(ProfileOwnerWatchButton);

class SubNavBarMobile extends React.Component<
  SubNavBarProps & WithTranslation & WithVerificationProps
> {
  render() {
    const {
      isOwner,
      routes,
      t,
      isVerificationNeeded,
      pushVerificationPopup,
      biClickProfileNavBar,
      isViewingAsVisitor,
      profileOwnerUser,
      onStartChat,
    } = this.props;

    // T42244: The sticky header gets stuck a pixel too low sometimes
    const stickyHeight = parseInt(cssVars['site-header-height-mobile']) - 1;

    let messageClickHandler: any = undefined;
    if (!isViewingAsVisitor) {
      if (isVerificationNeeded) {
        messageClickHandler = () => pushVerificationPopup('chat');
      } else {
        messageClickHandler = () => onStartChat(profileOwnerUser);
      }
    }

    return (
      <div className={s['root']}>
        <ErrorBoundary>
          {!isOwner && (
            <div className={s['action-buttons']}>
              <Button
                view="b2"
                fullWidth={false}
                className={s['message-btn']}
                onClick={messageClickHandler}
                height="large"
              >
                {t!(`common.chat`)}
              </Button>
              <WatchButtonMobile
                className={s['watch-btn']}
                disableClickHandler={isViewingAsVisitor}
                useV2Styles={false}
                height="large"
              />
            </div>
          )}
          <div className={s['sticky-placeholder']}>
            <Sticky zIndex={parseInt(s['z-index'])} marginTop={stickyHeight}>
              {isSticky => (
                <SubNavBarMobileInner
                  routes={routes}
                  isSticky={isSticky}
                  biClickProfileNavBar={biClickProfileNavBar}
                />
              )}
            </Sticky>
          </div>
        </ErrorBoundary>
      </div>
    );
  }
}

export default withRouter(withVerification(withTranslation()(SubNavBarMobile)));
